<template>
  <ul class="chooser">
    <li :class="{ selected: $i18n.locale === 'ru' }">
      <a href="#" @click.prevent="setLocale('ru')">
        <img src="@/assets/i/flag-ru.png" alt="" />
        <span>Русский</span>
      </a>
    </li>
    <li :class="{ selected: $i18n.locale === 'en' }">
      <a href="#" @click.prevent="setLocale('en')">
        <img src="@/assets/i/flag-en.png" alt="" />
        <span>English</span>
      </a>
    </li>
    <li :class="{ selected: $i18n.locale === 'zh' }">
      <a href="#" @click.prevent="setLocale('zh')">
        <img src="@/assets/i/flag-ch.png" alt="" />
        <span>中文</span>
      </a>
    </li>
    <li :class="{ selected: $i18n.locale === 'es' }">
      <a href="#" @click.prevent="setLocale('es')">
        <img src="@/assets/i/flag-es.png" alt="" />
        <span>Español</span>
      </a>
    </li>
    <li :class="{ selected: $i18n.locale === 'fr' }">
      <a href="#" @click.prevent="setLocale('fr')">
        <img src="@/assets/i/flag-fr.png" alt="" />
        <span>Français</span>
      </a>
    </li>
    <li :class="{ selected: $i18n.locale === 'de' }">
      <a href="#" @click.prevent="setLocale('de')">
        <img src="@/assets/i/flag-de.png" alt="" />
        <span>Deutsch</span>
      </a>
    </li>
    <li :class="{ selected: $i18n.locale === 'it' }">
      <a href="#" @click.prevent="setLocale('it')">
        <img src="@/assets/i/flag-it.png" alt="" />
        <span>Italiano</span>
      </a>
    </li>
    <li :class="{ selected: $i18n.locale === 'ja' }">
      <a href="#" @click.prevent="setLocale('ja')">
        <img src="@/assets/i/flag-jp.png" alt="" />
        <span>日本語</span>
      </a>
    </li>
    <li :class="{ selected: $i18n.locale === 'ko' }">
      <a href="#" @click.prevent="setLocale('ko')">
        <img src="@/assets/i/flag-kr.png" alt="" />
        <span>한국인</span>
      </a>
    </li>
  </ul>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LanguageSelection",
  data: () => {
    return {};
  },
  methods: {
    ...mapActions({
      setLocale: "SET_LOCALE"
    })
  }
};
</script>

<style scoped></style>
